import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { ServicingCommonModel, ServicingFunctionIdType } from '@common/interfaces';
import { MyBooking } from '@common/interfaces/mybooking/mybooking.interface';
import { ServicingPageIdType } from '@common/interfaces';
import { CreateSkLkrlStoreService } from '@common/services/my-booking/create-sk-lkrl/create-sk-lkrl.service';
import { MyBookingStoreService } from '@common/services/my-booking/my-booking-store.service';
import { MyBookingService } from '@common/services/my-booking/my-booking.service';
import { SupportModalBlockComponent } from '@lib/components/support-class';
import { AlertMessageItem, AlertType, ApiErrorResponseModel, PageType } from '@lib/interfaces';
import { StaticMsgPipe } from '@lib/pipes';
import { CommonLibService, ErrorsHandlerService, PageLoadingService } from '@lib/services';
import { AswServiceState, selectAswServiceState } from '@lib/store';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { CreateSkLkrlRequest, DefaultService as ServicingApiService } from 'src/sdk-servicing';
import { createAddReservationEticketNumberForm, createAddReservationReservationNumberForm } from './add-linked.form';
import { ServicingCommonStoreService } from '@common/services';
import { ErrorCodeConstants } from '@conf/app.constants';

@Component({
  selector: 'asw-add-linked',
  templateUrl: './add-linked.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddLinkedComponent extends SupportModalBlockComponent {
  subPageId: string = ServicingPageIdType.MY_BOOKING;
  subFunctionId: string = ServicingFunctionIdType.BOOKING_CONFIRMATION;

  public isInit: boolean = false;
  public id = this.constructor.name;
  public isETicketNumber: boolean = false;
  public reservationList: Array<string> = [
    this.staticMsg.transform('label.recLoc'),
    this.staticMsg.transform('label.eTicketNumber'),
  ];
  public selectItemValue: number = 0;

  // (18) 検索対象選択ボタン押下処理
  // 1.	画面表示内容に従い、画面.関連PNR追加エリアの表示を切り替える。
  public selectedItem: string = '';

  public reservationNumberForm = createAddReservationReservationNumberForm();
  public eTicketNumberForm = createAddReservationEticketNumberForm();
  private aswServiceStoreData?: AswServiceState;
  constructor(
    private _common: CommonLibService,
    public staticMsg: StaticMsgPipe,
    private _errorsHandlerSvc: ErrorsHandlerService,
    private _createSkLkrlStoreService: CreateSkLkrlStoreService,
    private _store: Store,
    private _myBookingService: MyBookingService,
    private readonly _router: Router,
    private _myBookingStoreService: MyBookingStoreService,
    private readonly _servicingApiService: ServicingApiService,
    private _servicingCommonStoreService: ServicingCommonStoreService,
    private _loadingSvc: PageLoadingService
  ) {
    super(_common);
    this.closeWithUrlChange(this._router);
    this.refresh();
  }
  reload(): void {}
  init(): void {
    this.selectedItem = this.reservationList[0];
  }
  destroy(): void {}
  refresh() {
    this.isInit = true;
  }

  /** (21) 関連PNR追加エリア閉じるボタン押下処理  */
  clickClose() {
    // 1.	関連PNR追加エリアのモーダルを非表示にする。
    this.clickCloseSub();
  }

  clickCloseSub() {
    this.close();
  }

  hankana2zenkana(str: string) {
    const kanaMap: { [key: string]: string } = {
      ｶﾞ: 'ガ',
      ｷﾞ: 'ギ',
      ｸﾞ: 'グ',
      ｹﾞ: 'ゲ',
      ｺﾞ: 'ゴ',
      ｻﾞ: 'ザ',
      ｼﾞ: 'ジ',
      ｽﾞ: 'ズ',
      ｾﾞ: 'ゼ',
      ｿﾞ: 'ゾ',
      ﾀﾞ: 'ダ',
      ﾁﾞ: 'ヂ',
      ﾂﾞ: 'ヅ',
      ﾃﾞ: 'デ',
      ﾄﾞ: 'ド',
      ﾊﾞ: 'バ',
      ﾋﾞ: 'ビ',
      ﾌﾞ: 'ブ',
      ﾍﾞ: 'ベ',
      ﾎﾞ: 'ボ',
      ﾊﾟ: 'パ',
      ﾋﾟ: 'ピ',
      ﾌﾟ: 'プ',
      ﾍﾟ: 'ペ',
      ﾎﾟ: 'ポ',
      ｳﾞ: 'ヴ',
      ﾜﾞ: 'ヷ',
      ｦﾞ: 'ヺ',
      ｱ: 'ア',
      ｲ: 'イ',
      ｳ: 'ウ',
      ｴ: 'エ',
      ｵ: 'オ',
      ｶ: 'カ',
      ｷ: 'キ',
      ｸ: 'ク',
      ｹ: 'ケ',
      ｺ: 'コ',
      ｻ: 'サ',
      ｼ: 'シ',
      ｽ: 'ス',
      ｾ: 'セ',
      ｿ: 'ソ',
      ﾀ: 'タ',
      ﾁ: 'チ',
      ﾂ: 'ツ',
      ﾃ: 'テ',
      ﾄ: 'ト',
      ﾅ: 'ナ',
      ﾆ: 'ニ',
      ﾇ: 'ヌ',
      ﾈ: 'ネ',
      ﾉ: 'ノ',
      ﾊ: 'ハ',
      ﾋ: 'ヒ',
      ﾌ: 'フ',
      ﾍ: 'ヘ',
      ﾎ: 'ホ',
      ﾏ: 'マ',
      ﾐ: 'ミ',
      ﾑ: 'ム',
      ﾒ: 'メ',
      ﾓ: 'モ',
      ﾔ: 'ヤ',
      ﾕ: 'ユ',
      ﾖ: 'ヨ',
      ﾗ: 'ラ',
      ﾘ: 'リ',
      ﾙ: 'ル',
      ﾚ: 'レ',
      ﾛ: 'ロ',
      ﾜ: 'ワ',
      ｦ: 'ヲ',
      ﾝ: 'ン',
      ｧ: 'ァ',
      ｨ: 'ィ',
      ｩ: 'ゥ',
      ｪ: 'ェ',
      ｫ: 'ォ',
      ｯ: 'ッ',
      ｬ: 'ャ',
      ｭ: 'ュ',
      ｮ: 'ョ',
      '｡': '。',
      '､': '、',
      ｰ: 'ー',
      '｢': '「',
      '｣': '」',
      '･': '・',
    };

    var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
    return str
      .replace(reg, function (match) {
        return kanaMap[match];
      })
      .replace(/ﾞ/g, '゛')
      .replace(/ﾟ/g, '゜');
  }

  hiraganaToKatakana(input: string) {
    return input.replace(/[\u3041-\u3096]/g, function (match) {
      var charCode = match.charCodeAt(0) + 0x60;

      return String.fromCharCode(charCode);
    });
  }

  convertName(name: string) {
    return this.hankana2zenkana(this.hiraganaToKatakana(name));
  }

  hankk2zenkk(str: string) {
    return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });
  }

  /** (19) 関連PNR追加ボタン押下処理 */
  onLink() {
    this._store.select(selectAswServiceState).subscribe((res) => {
      this.aswServiceStoreData = res;
    });
    const linkReservationFrom = {
      orderId: this.aswServiceStoreData?.orderId ?? '',
      credential: {
        lastName: this.aswServiceStoreData?.lastName ?? '',
        firstName: this.aswServiceStoreData?.firstName ?? '',
      },
    };
    const currentForm = this.selectItemValue === 0 ? this.reservationNumberForm : this.eTicketNumberForm;

    const firstName = currentForm.controls.firstName.value ?? '';
    const lastName = currentForm.controls.lastName.value ?? '';

    currentForm.controls.firstName.patchValue(this.convertName(firstName));
    currentForm.controls.lastName.patchValue(this.convertName(lastName));

    if (currentForm.invalid) {
      this._errorsHandlerSvc.setRetryableError(PageType.SUBPAGE);
      return;
    }
    if (firstName?.length + lastName?.length > 55) {
      this._errorsHandlerSvc.setRetryableError(PageType.SUBPAGE, {
        errorMsgId: 'E0406',
      });
      return;
    }
    this._errorsHandlerSvc.clearRetryableError();

    const request: CreateSkLkrlRequest = {
      linkReservationFrom: linkReservationFrom,
      linkReservationTo: {
        orderId: this.selectItemValue === 0 ? this.reservationNumberForm.controls.reservationNumber.value! : undefined,
        eTicketNumber: this.selectItemValue === 1 ? this.eTicketNumberForm.controls.ticketNumber.value! : undefined,
        credential: {
          firstName,
          lastName,
        },
      },
    };
    this.callCreateSkLkrlApi(request);
  }

  callCreateSkLkrlApi(request: CreateSkLkrlRequest) {
    this._loadingSvc.startLoading();
    this._servicingApiService
      .ordersCreateSkLkrlPost(request)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.handleSuccess();
        },
        error: (error) => {
          this.handleError(error);
        },
      });
  }

  handleError(error: ApiErrorResponseModel) {
    /**
     * 以下表の1行目から順に、APIレスポンス.errorsについて、当該error.コード=エラーコードとなるエラーコードが含まれるかを確認し、
     * 最初に含まれるエラーコードについて、そのエラーコードの行に応じたエラーメッセージIDを求める。
     */
    const apiErrorCode = this._common.apiError?.errors?.[0]?.code ?? '';
    const errorMsgId = this.getErrorMsgId(apiErrorCode);
    this._common.errorsHandlerService.setRetryableError(PageType.SUBPAGE, {
      apiErrorCode,
      errorMsgId: errorMsgId,
    });
    this._loadingSvc.endLoading();
  }

  handleSuccess() {
    // 提携: 関連PNRを追加した時に、サービシング共通store.PNR情報取得API応答をクリアする(UIUXs2起因)
    const servicingCommonModel: ServicingCommonModel = {
      completedFunction: 'linkOrder',
      getOrder: {},
    };
    this._servicingCommonStoreService.updateServicingCommon(servicingCommonModel);
    this._common.aswServiceStoreService.updateAswService({ orderId: this.aswServiceStoreData?.orderId });
    this.close();
    // 2.2.1.1.	予約詳細store.登録完了時機能種別に“linkOrder”(関連PNR追加)を設定し、当モーダルを閉じて当画面を再表示する。
    this._myBookingService.setAddReservation(true);
    this._myBookingService.runOnInit();
    this._loadingSvc.endLoading();
  }

  getErrorMsgId(errCode: string): string {
    switch (errCode) {
      /** "EBAZ000159”(PNR情報の取得に失敗) => "E0400"(予約の特定ができない旨) */
      case ErrorCodeConstants.ERROR_CODES.EBAZ000159:
        return 'E0400';
      /** "EBAZ000197”(登録失敗) => "E0746”(関連PNRの登録に失敗した旨) */
      case ErrorCodeConstants.ERROR_CODES.EBAZ000197:
        return 'E0746';
      default:
        return '';
    }
  }

  /** (20) 関連PNRモーダル閉じるボタン押下処理 */
  closeModal() {
    // 1.	関連PNRモーダルを非表示にする。
    this.close();
  }
}
